module.exports = __webpack_public_path__ + "img/icomoon.fa9be3c.svg";